// Shared subscription buybox for Vedkungen buyforms (smasack, storsack, etc.).
// Expects markup from snippets/vedkungen-buybox.liquid.
(function () {
  function formatMoney(amount) {
    amount = Math.round(Number(amount));
    return amount.toLocaleString('sv-SE') + ' kr';
  }

  // Get default selling plan for a variant
  function getDefaultSellingPlan(variant) {
    return variant?.selling_plans?.[0] ?? null;
  }

  // Calculate selling plan save amount against one-time variant price
  function getSellingPlanSaveAmount(variantPrice, planPrice) {
    if (!variantPrice || planPrice >= variantPrice) return 0;
    return variantPrice - planPrice;
  }

  function createBuybox(config) {
    const {
      state,
      onPriceChange = () => {},
      getOrderPricing = null,
      buyboxSelector = '[data-vedkungen-buybox]',
      blockerSelector = '.buybox-blocker',
      frequencySelector = '[data-buybox-frequency]',
    } = config;

    if (!state) {
      throw new Error('[VedkungenBuybox] state object is required');
    }

    state.buyboxBlockVisible = state.buyboxBlockVisible ?? false;
    state.purchaseType = state.purchaseType ?? 'one_time';
    state.sellingPlan = state.sellingPlan ?? null;

    function getBuybox() {
      return document.querySelector(buyboxSelector);
    }

    // Show buybox and hide the blocker notice
    function show() {
      if (state.buyboxBlockVisible) return;

      const blocker = document.querySelector(blockerSelector);
      const buybox = getBuybox();
      if (blocker) blocker.style.display = 'none';
      if (buybox) buybox.style.display = 'block';
      state.buyboxBlockVisible = true;
    }

    // Hide buybox and show the blocker notice again
    function hide() {
      if (!state.buyboxBlockVisible) return;

      const blocker = document.querySelector(blockerSelector);
      const buybox = getBuybox();
      if (blocker) blocker.style.display = '';
      if (buybox) buybox.style.display = 'none';
      state.buyboxBlockVisible = false;
    }

    function getOneTimeDisplayPrice() {
      const pricing = getOrderPricing?.();
      if (pricing) return pricing.oneTimeTotal;
      return state.variant?.price ?? 0;
    }

    function getPlanDisplayPricing(plan) {
      const pricing = getOrderPricing?.();

      if (pricing) {
        const planPricing = pricing.selling_plans?.find((entry) => entry.id === plan.id);

        if (planPricing) {
          return {
            total: planPricing.total,
            compareTotal: pricing.oneTimeTotal,
          };
        }
      }

      return {
        total: plan.price,
        compareTotal: state.variant?.price ?? 0,
      };
    }

    function updateOneTimeDisplay() {
      const buybox = getBuybox();
      if (!buybox) return;

      const oneTimePrice = buybox.querySelector('[data-buybox-one-time-price]');
      if (oneTimePrice) {
        oneTimePrice.textContent = formatMoney(getOneTimeDisplayPrice());
      }
    }

    // Update subscription price, compare price, and save badge
    function updateSubscriptionDisplay(plan) {
      const buybox = getBuybox();
      if (!buybox) return;

      const priceEl = buybox.querySelector('[data-buybox-subscription-price]');
      const compareEl = buybox.querySelector('[data-buybox-subscription-compare-price]');
      const badgeEl = buybox.querySelector('[data-buybox-badge]');

      if (!plan) {
        if (priceEl) priceEl.textContent = '';
        if (compareEl) compareEl.hidden = true;
        if (badgeEl) badgeEl.hidden = true;
        return;
      }

      const { total, compareTotal } = getPlanDisplayPricing(plan);

      if (priceEl) priceEl.textContent = formatMoney(total);

      if (compareEl) {
        if (compareTotal > total) {
          compareEl.textContent = formatMoney(compareTotal);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      const saveAmount = getSellingPlanSaveAmount(compareTotal, total);
      if (badgeEl) {
        if (saveAmount > 0) {
          badgeEl.textContent = `Spara ${formatMoney(saveAmount)}`;
          badgeEl.hidden = false;
        } else {
          badgeEl.hidden = true;
        }
      }
    }

    function refreshPricing() {
      updateOneTimeDisplay();
      updateSubscriptionDisplay(state.sellingPlan);
    }

    // Select one-time purchase or subscription
    function selectOption(type) {
      const buybox = getBuybox();
      if (!buybox) {
        console.warn('[VedkungenBuybox] Buybox not found');
        return;
      }

      const oneTimeBox = buybox.querySelector('.buybox__option--one-time');
      const subscriptionBox = buybox.querySelector('.buybox__option--subscription');

      state.purchaseType = type === 'selling_plan' ? 'subscription' : 'one_time';

      buybox.querySelectorAll('.buybox__option').forEach((box) => {
        box.classList.remove('buybox__option--selected', 'buybox__option--active');
      });

      if (state.purchaseType === 'subscription' && subscriptionBox) {
        subscriptionBox.classList.add('buybox__option--selected', 'buybox__option--active');
      } else if (oneTimeBox) {
        oneTimeBox.classList.add('buybox__option--selected', 'buybox__option--active');
      } else if (subscriptionBox) {
        subscriptionBox.classList.add('buybox__option--selected', 'buybox__option--active');
        state.purchaseType = 'subscription';
      }

      onPriceChange();
    }

    // Render selling plan frequency options
    function renderSellingPlanFrequency(variant) {
      const container = document.querySelector(frequencySelector);
      if (!container) return;

      const plans = variant?.selling_plans || [];
      container.innerHTML = '';

      // If no selling plans found, hide container and return
      if (plans.length === 0) {
        container.hidden = true;
        return;
      }

      container.hidden = false;

      plans.forEach((plan) => {
        const isSelected = plan.id === state.sellingPlan?.id;
        const label = document.createElement('label');
        label.className = 'buybox__frequency-option';

        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'buybox-selling-plan';
        input.dataset.sellingPlanId = plan.id;
        input.checked = isSelected;
        input.style.display = 'none';

        const indicator = document.createElement('span');
        indicator.className = 'buybox__frequency-indicator';
        if (isSelected) indicator.classList.add('buybox__frequency-indicator--checked');

        const planName = document.createElement('span');
        planName.className = 'buybox__frequency-name';
        planName.textContent = plan.name;

        label.appendChild(input);
        label.appendChild(indicator);
        label.appendChild(planName);
        container.appendChild(label);

        // Frequency option click handler
        label.addEventListener('click', () => {
          state.sellingPlan = plan;
          container.querySelectorAll('.buybox__frequency-indicator').forEach((el) => {
            el.classList.remove('buybox__frequency-indicator--checked');
          });
          indicator.classList.add('buybox__frequency-indicator--checked');
          input.checked = true;
          selectOption('selling_plan');
        });
      });
    }

    // Sync buybox UI with the current variant (prices, plans, selection)
    function update(variant) {
      const buybox = getBuybox();
      if (!buybox || !variant) return;

      state.variant = variant;

      const previousPlanId = state.sellingPlan?.id;
      state.sellingPlan = variant.selling_plans?.find((plan) => plan.id === previousPlanId)
        || getDefaultSellingPlan(variant);

      renderSellingPlanFrequency(variant);
      refreshPricing();

      const hasSellingPlans = variant.selling_plans?.length > 0;
      const subscriptionBox = buybox.querySelector('.buybox__option--subscription');
      if (subscriptionBox) {
        subscriptionBox.hidden = !hasSellingPlans;
      }

      // Toggle wrapper variants when markup provides both (ONLY applies to ved-bundle.liquid)
      const noSubWrapper = buybox.querySelector('.buybox__nosubscription');
      const subWrapper = buybox.querySelector('.buybox__subscription');
      if (noSubWrapper) noSubWrapper.style.display = hasSellingPlans ? 'none' : '';
      if (subWrapper) subWrapper.style.display = hasSellingPlans ? '' : 'none';

      if (!hasSellingPlans || state.purchaseType === 'one_time') {
        selectOption('one_time_purchase');
      } else {
        selectOption('selling_plan');
      }
    }

    // Initialize buybox event listeners and default selection
    function init(variant) {
      const buybox = getBuybox();
      if (!buybox) return;

      // Purchase option click handlers (one-time vs subscription)
      buybox.querySelectorAll('.buybox__purchase-option').forEach((option) => {
        option.addEventListener('click', () => {
          selectOption(option.dataset.boxType);
        });
      });

      // If product requires selling plan, default to subscription
      if (!buybox.querySelector('.buybox__option--one-time')) {
        state.purchaseType = 'subscription';
      }

      update(variant);
    }

    return {
      init,
      update,
      show,
      hide,
      selectOption,
      refreshPricing,
    };
  }

  // Renewal date from delivery month: YYYY-MM-DD and Swedish month label for order attributes / emails.
  function getRenewalDate(deliverymonth, interval) {
    if (!deliverymonth || deliverymonth === 'none') {
      return { date: null, label: null };
    }

    let year;
    let month;

    if (deliverymonth === 'now') {
      const now = new Date();
      year = now.getFullYear();
      month = now.getMonth() + 1;
    } else {
      [year, month] = deliverymonth.split('-').map(Number);
    }

    // TODO hardcoded, should be configurable if products have different renewal intervals
    if (interval === 'month') { // småsäck
      month += 1;
      if (month > 12) {
        month = 1;
        year += 1;
      }
    } else { // storsäck
      year += 1;
    }

    const monthPadded = String(month).padStart(2, '0');
    const yearMonth = `${year}-${monthPadded}`;
    const labelDate = new Date(`${yearMonth}-01`);
    const label = `${labelDate.toLocaleString('sv-SE', { month: 'long' })} ${year}`;

    return {
      date: `${yearMonth}-01`,
      label,
    };
  }

  window.VedkungenBuybox = { create: createBuybox, getRenewalDate };
})();
